export default function (path) {
  return path.substring(
    path.lastIndexOf('/') === -1 ? 0 : (path.lastIndexOf('/') + 1),
  );
}
